import { render } from "./FloatingMobileNav.vue?vue&type=template&id=33524081"
import script from "./FloatingMobileNav.vue?vue&type=script&lang=js"
export * from "./FloatingMobileNav.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__